import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item', 'selection', 'searchbox', 'filteringItems'];

  filter(event) {
    const filterValue = event.target.value.toLowerCase();

    let matches = 0;

    this.itemTargets.forEach((item) => {
      const itemValue = item.dataset.searchValue.toLowerCase();
      if (itemValue.includes(filterValue)) {
        item.classList.remove('hidden');
        matches += 1;
      } else {
        item.classList.add('hidden');
      }
    });

    if (this.hasSearchboxTarget) {
      if (matches === 0) {
        this.searchboxTarget.classList.add('hidden');
      } else {
        this.searchboxTarget.classList.remove('hidden');
      }
    }

    if (filterValue === '') {
      this.resetGroupHeaders();
      if (this.hasFilteringItemsTarget) {
        this.filteringItemsTarget.classList.add('hidden');
      }
    } else {
      this.updateGroupHeaders();
      if (this.hasFilteringItemsTarget) {
        this.filteringItemsTarget.classList.remove('hidden');
      }
    }
  }

  resetGroupHeaders() {
    const groupHeaders = this.element.querySelectorAll('[data-group-header]');
    groupHeaders.forEach((header) => {
      header.classList.remove('hidden');
    });
  }

  updateGroupHeaders() {
    const groupHeaders = this.element.querySelectorAll('[data-group-header]');

    groupHeaders.forEach((header) => {
      const groupId = header.dataset.groupHeader;
      const groupItems = this.element.querySelectorAll(
        `[data-group-member="${groupId}"]:not(.hidden)`,
      );

      if (groupItems.length === 0) {
        header.classList.add('hidden');
      } else {
        header.classList.remove('hidden');
      }
    });
  }

  select(event) {
    if (this.hasSelectionTarget) {
      this.selectionTarget.value = event.target.dataset.searchValue;
    }
  }

  preventSubmit(event) {
    event.preventDefault();
  }
}
